import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {
  private datePipe: DatePipe;
  constructor(private translateService: TranslateService) {
    this.datePipe = new DatePipe(this.translateService.currentLang);
  }

  transform(value: Date|string, pattern: string = 'mediumDate'): any {  
    if(typeof value === "string") value = new Date(value);    
    if(!value || isNaN(value.valueOf())) return "";
    return this.datePipe.transform(value, pattern, undefined, this.translateService.currentLang);
  }
}
